import { IIconProps } from '~/types';

const EditIcon = (props:IIconProps) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.25 3.75H4.5A1.5 1.5 0 0 0 3 5.25v8.25A1.5 1.5 0 0 0 4.5 15h8.25a1.5 1.5 0 0 0 1.5-1.5V9.75m-1.06-7.06a1.5 1.5 0 0 1 2.12 2.12l-6.439 6.44H6.75V9.129z"
      stroke="#313036"
      strokeWidth={1.25}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default EditIcon;
